// Third-party
import React from 'react';

// Components
import { FormattedMessage } from '../../../../../utils/i18n';
import ColorSelector from '../../../../../views/components/misc/ColorSelector';
import { Typography } from '@capintel/component-lib/typography';

// Utils
import * as ProposalNS from '../../../Proposal';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';
import { PROPOSAL_BANNER_STYLES } from '../../../utils/constants';

type Props = {
  onHeaderColorChange?: (pattern: string) => void;
  styleOptions: ProposalNS.ProposalStyleOptionsV2;
};

const ProposalColorSelector: React.FunctionComponent<Props> = ({ onHeaderColorChange, styleOptions }: Props) => {
  if (!styleOptions || !styleOptions.banners) {
    return null;
  }

  return (
    <div className="proposal-option">
      <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
        <FormattedMessage id="Proposal.Tabs.Options.HeaderColor" />
      </Typography>

      <ColorSelector onChange={onHeaderColorChange} colors={PROPOSAL_BANNER_STYLES.map(s => s.background)} selected={styleOptions.banners.background} />
    </div>
  );
};

export default ProposalColorSelector;
